import { useMutation } from "@tanstack/react-query";

import { VerifyMfaCodeRequest, VerifyMfaCodeResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";
import { ToastType } from "@/enums/toast";

export const useVerifyMfaCode = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useMutation(
    (body: VerifyMfaCodeRequest): Promise<VerifyMfaCodeResponse> =>
      fetch(ENDPOINTS.mfa.verify, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse),
    {
      onSuccess: ({ access_token, valid, user }) => {
        if (valid) {
          auth?.updateAccessToken(access_token);
          auth?.updateUserState(user);
          displayToast("MFA verified successfully", ToastType.success);
        } else {
          displayErrorToast("Invalid MFA code. Please try again.");
        }
      },
      onError: (error: string) => {
        displayErrorToast(error);
      },
    },
  );
};
